import { createContext } from 'react';

import { ActionStyle, ButtonTheme } from '@philips-emr/tws-constants';

export interface Action {
  buttonTheme?: ButtonTheme;
  enabled: boolean;
  icon?: string;
  id: string;
  onClick: (...args: any) => any;
  style: ActionStyle;
  text: string;
}

class ContextualBarContext {
  static Context = createContext(new ContextualBarContext());

  private actions: Map<string, Action> = new Map();
  private actionListeners: Set<Function> = new Set();

  private title: string = '';
  private titleListeners: Set<Function> = new Set();

  addTitleListener(fn: Function): Function {
    if (this.titleListeners.has(fn)) {
      throw Error('[ContextualBar Context]: This listener is already listening to title changes.');
    }

    this.titleListeners.add(fn);

    return () => {
      this.titleListeners.delete(fn);
    };
  }

  addActionListener(fn: Function): Function {
    if (this.actionListeners.has(fn)) {
      throw Error('[ContextualBar Context]: This listener is already listening to action changes.');
    }

    this.actionListeners.add(fn);

    return () => {
      this.actionListeners.delete(fn);
    };
  }

  setTitle(title: string): void {
    this.title = title;
    this.titleListeners.forEach((listener) => listener());
  }

  getTitle(): string {
    return this.title;
  }

  addOrUpdateAction(action: Action): Function {
    const { id } = action;

    this.actions.set(id, action);
    this.actionListeners.forEach((listener) => listener());

    return () => {
      this.actions.delete(id);
      this.actionListeners.forEach((listener) => listener());
    };
  }

  getActions(): Action[] {
    return Array.from(this.actions.values());
  }
}

export default ContextualBarContext;
